import type { FormsApiClient } from '../api';
import type { LeadFormPublicConfig } from '../types';
import { applyThemeVars, buildCloseButton, buildForm, buildHeader, createHost, resolvePopupStyle, SHARED_PANEL_STYLE, type LeadFormTheme, type RenderHandle } from './shared';

const STYLE = `
  ${SHARED_PANEL_STYLE}
  .overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,0.5);
    display: flex; align-items: center; justify-content: center;
    z-index: 2147483000;
  }
  .panel { width: min(420px, 90vw); }
`;

export function renderLightbox(
  form: LeadFormPublicConfig,
  client: FormsApiClient,
  onSubmit: (data: Record<string, unknown>) => Promise<boolean>,
): RenderHandle {
  const theme = form.theme as LeadFormTheme;
  const resolved = resolvePopupStyle(theme);

  const { host, root } = createHost(STYLE);

  const overlay = document.createElement('div');
  overlay.className = 'overlay';

  const panel = document.createElement('div');
  panel.className = 'panel';
  applyThemeVars(panel, resolved);

  panel.appendChild(buildCloseButton(close));
  for (const el of buildHeader(form, client, panel)) {
    panel.appendChild(el);
  }
  panel.appendChild(buildForm(form.fields, theme.ctaLabel || 'Submit', onSubmit, close));

  overlay.appendChild(panel);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });
  root.appendChild(overlay);

  function close() {
    host.remove();
  }

  return { close };
}
